import React from "react"
import AddViewContent from "../../../../../core/gd-ui/add-view/add-view-content"
import NewProjectView_getViewsStructure
    from "../../../../../core/model2/custom-view/add-custom-view/get-structure-for-project"

type Props = {
    className?              : string

    menuParams             : {
        projectId              : ID
    }

    selectedGroupId         : ID    // default category for views

    hidePopover             : callback
}

// const debug = "NavigationMenuNewView"
const debug = false

export default function NavigationMenuAdd_PopoverNewView(props:Props) {

    const groupedItems  = NewProjectView_getViewsStructure(props.menuParams.projectId)

    debug && console.log(debug, 'render', groupedItems)

    return (
        <AddViewContent viewsStructure  = {groupedItems}
                        selectedGroupId = {props.selectedGroupId}
                        hidePopover     = {props.hidePopover}/>
    )
}